import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  paperStyle: {
    padding: '6px',
    marginBottom: '10px',
    '& .MuiTableCell-root': {
      textAlign: 'center',
      '& label': {
        textAlign: 'left',
      },
      '& .MuiTableCell-head': {
        textAlign: 'left',
      },
    },
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  header: {
    backgroundColor: 'rgb(138,138,138)',
    padding: '10px 5px',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '18px',
    borderRadius: '3px',
  },
  selectionButton: {
    backgroundColor: 'rgb(62,67,69)',
    textAlign: 'center',
    height: '30px',
  },
  container: {
    maxHeight: '60vh',
    minHeight: '60vh',
    overflowX: 'auto',
  },
  dropDownSelector: {
    minWidth: 140,
  },
  divHorizontal: {
    display: 'flex',
  },
  buttonHeight: {
    height: '70%',
  },
  viewReportModal: {
    width: 'auto',
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        maxWidth: 'none',
        overflowX: 'hidden',
      },
    },
  },
  cellWrapper: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
  },
  viewReportModalContent: {
    color: '#fff',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    borderTop: '2px solid lightgrey',
    overflowX: 'auto',
  },
  viewReportModalButton: {
    backgroundColor: 'rgb(62,67,69)',
    textAlign: 'center',
  },
  tabPanel: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  availabilityFilterLabel: {
    textTransform: 'none',
    justifyContent: 'start',
  },
  availabilityButton: {
    maxWidth: 250,
    overflow: 'hidden',
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 41,
    float: 'left',
    marginBottom: 0,
    backgroundColor: '#f7f9fa',
  },
  searchBar: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
}));

export default styles;
